import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/functions'

// firebase init
var firebaseConfig = {
  apiKey: "AIzaSyDEsFCgWRlfAUNllNmejJnE-BAyCyZo2Ok",
  authDomain: "rpi-timelapse-a6e5b.firebaseapp.com",
  projectId: "rpi-timelapse-a6e5b",
  storageBucket: "rpi-timelapse-a6e5b.appspot.com",
  messagingSenderId: "408401752251",
  appId: "1:408401752251:web:aed29e0f5ddbe8f272799e",
  measurementId: "G-B28FKT49WD"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
var storage = firebase.storage()
const functions = firebase.app().functions('europe-west2')

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')
const userPermissions = db.collection('user_permissions')
const cameraCollection = db.collection('cameras')
const editCollection = db.collection('edits')
const inductionCollection  = db.collection('inductions')
const calEvent  = db.collection('calendar')

//storage references
// const cameraStorage = storage.ref('/sites')


// export utils/refs
export {
  db,
  auth,
  usersCollection,
  postsCollection,
  commentsCollection,
  likesCollection,
  userPermissions,
  cameraCollection,
  storage,
  calEvent,
  inductionCollection,
  functions,
  editCollection

}
